import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { BlockDataService } from '../block-services/block-data.service'
import { CategoriesService } from '../blocks-wrapper/block-categories/categories.service'
import { BuilderService } from '../builder-services/builder.service'
import { LoginService } from '../login/login.service'
import { environment } from 'src/environments/environment'
import { BlockFieldsService } from '../block-services/block-fields.service'
import { AppSettingsService } from '../settings/services/app-settings.service'
import { CountriesService } from '../builder-services/countries/countries.service'
import { MixpanelService } from '../tracking/mixpanel.service'
import { LanguageService } from '../language.service'
import { TranslateService } from '@ngx-translate/core'
import { SubscriptionFlowService } from '../subscription-flow/subscription-flow.service'
import { VendorService } from '../multivendor/vendor.service'
import { VersionsService } from '../pages/versions/versions.service'
import { PagesService } from '../pages/website-builder/pages.service'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ViewsService } from '../views/views.service'
import { AddonsAccessService } from '../addons/addons-subscribtion/addons-access.service'
import { CheckoutFieldsService } from '../e-commerce/shipping-providers/shared/checkout-fields.service'
import { SideMenuItemsService } from '../blocks-wrapper/block-sidemenu/side-menu-items.service'

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  objectValues = Object.values
  private user_email
  projectUrl = ''
  mobile = false
  environment = environment
  multiProjects = false
  projectsLimit: any = 1
  projectsLength: any = 1
  trialsCount = 0
  premiumCount = 0
  spinnerVal = 0
  mobile_webview_link = ''
  finishedFetchingProject = false
  selectedCode: any
  siteLangLocalStorage: any = ''
  toggleSidebar = false
  websitePages: any[] = []
  constructor(
    private sideMenuItems: SideMenuItemsService,
    public builderService: BuilderService,
    public blockDataService: BlockDataService,
    private blockFieldsService: BlockFieldsService,
    public loginService: LoginService,
    public languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private categoriesService: CategoriesService,
    private appSettingsService: AppSettingsService,
    public countries: CountriesService,
    private translate: TranslateService,
    private mixPanel: MixpanelService,
    public vendor: VendorService,
    public SubscriptionFlow: SubscriptionFlowService,
    private versions: VersionsService,
    private pagesService: PagesService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public viewsService: ViewsService,
    private addonsAccess: AddonsAccessService,
    private checkoutFieldsService: CheckoutFieldsService
  ) {
    let code = navigator.language
    if (this.countries.countryListAllIsoData.find((obj) => obj.code === code)) {
      this.countries.selectedCountry = [this.countries.countryListAllIsoData.find((obj) => obj.code === code)]
    }

    if (code !== 'en') {
      this.countries.selectedCountry.push(this.countries.countryListAllIsoData.find((obj) => obj.code === 'en'))
    }
    this.user_email = loginService.getCurrentUser().email
    /**
     * Get All Projects in the constructor
     */
    this.getAllProjects()

    /**
     * Get Projects limit to display for the customer
     */
    this.builderService.getProjectsLimit().subscribe((projectsLimit) => {
      this.projectsLimit = projectsLimit
      this.spinnerVal = (this.premiumCount / this.projectsLimit) * 100
      this.builderService.projectsLimit = this.projectsLimit
      this.builderService.projectsPremiumCount = this.premiumCount
    })

    if (localStorage.getItem('token')) {
      this.blockDataService.sendTokenData(localStorage.getItem('token'))
    }
    // let projectId = String(localStorage.getItem("selectedProject"));
    // if(projectId) {
    //   this.blockDataService.sendProjectData(projectId);
    // }
  }
 
  /**
   * Get all projects and sets the localstorage
   */
  getAllProjects = () => {
    this.builderService.getProjects(this.user_email).subscribe(
      (allProjects) => {
        this.trialsCount = 0
        this.premiumCount = 0
        let projectsIds = []
        // if(allProjects[0] == null) {
        //   alert("you don't have active subscriptions, please go to the main website to renew your subscription")
        // }
        this.builderService.projects = []
        for (const key in allProjects) {
          if (Object.prototype.hasOwnProperty.call(allProjects, key)) {
            const element = allProjects[key]
            if (element.type == '') {
              element.type = 'purchase'
            }
            this.builderService.projects.push({ id: element.id, status: element.status, type: element.type, domain: element.domain, email: element.email, first_name: element.first_name, last_name: element.last_name, premium_status: element.premium_status, premium_package: element.premium_package })
            // this.categoriesIds.push(element.term_id);
            projectsIds.push(element.id)
            if (element.status == 'active') {
              if (element.type == 'trial') {
                this.trialsCount++
              } else {
                this.premiumCount++
              }
            }
          }
          this.builderService.projectsPremiumCount = this.premiumCount
        }
        this.projectsLength = allProjects.length
        if (allProjects.length > 1) {
          this.multiProjects = true
        }
        /**
         * If there is a selected project in the localstorage then retrieve
         */
        let projectId
        if (!projectsIds.includes(String(localStorage.getItem('selectedProject')))) {
          for (const key in allProjects) {
            if (Object.prototype.hasOwnProperty.call(allProjects, key)) {
              const element = allProjects[key]
              if (element.status == 'active') {
                projectId = element.id
                // localStorage.setItem('selectedProject', projectId)
              }
            }
          }
        } else {
          projectId = String(localStorage.getItem('selectedProject'))
        }
        this.blockDataService.sendProjectData(projectId)
        this.getProject(projectId)
      },
      (err) => {}
    )
  }

  ngOnInit() {
    if (window.screen.width <= 768) {
      // 768px portrait
      this.mobile = true
    }

    // Load website pages when header initializes
    this.loadWebsitePages()

    // Listen for website page changes to reload pages dropdown
    this.blockDataService.getSelectedWebsitePage().subscribe((page) => {
      if (page && page.reloadPages) {
        this.loadWebsitePages()
      }
    })
  }
  /**
   * Send getProject Request after selection
   * @param projectId
   */
  getProject = (projectId: any, type: string = 'default') => {
    this.builderService.showUpdateProgress = true
    const savedVendors = localStorage.getItem('superVendor');   
    const currentProject = localStorage.getItem('selectedProject');    
    if (savedVendors) projectId = currentProject
    this.builderService.selectedProject = projectId
    localStorage.setItem('selectedProject', projectId)
    localStorage.removeItem('categories')
    this.blockDataService.getProjectCached().subscribe(
      (project: any) => {
        // Cache the response
        this.builderService.cacheProjectReq.response = project
        if (type == 'clicked') {
          this.blockDataService.blocksData = JSON.parse(project['data'])
        }
        // Update the Builder View
        if (this.blockDataService.blocksData == null) {
          this.blockDataService.blocksData = []
          let headerData = this.blockFieldsService.getHeaderBlockFields()
          headerData.id = this.blockDataService.getUniqueId(2)
          this.blockDataService.blocksData.unshift(headerData)
        }
        this.blockDataService.sendRenderAllBlocks()
        // Update the Settings (is_premium comes from the effective plan in builderService.loadProjectPlan)
        if (project.premium.length) {
          for (let index = 0; index < project.premium.length; index++) {
            const element = project.premium[index]
            this.builderService.premium_status = element.status
            this.builderService.stripe_subscription_id = element.stripe_subscription_id
            this.blockDataService.sendStripeData(element.stripe_subscription_id)
            this.builderService.premium_start_date = element.start_date
            if (element.status == 'active') {
              this.builderService.active_subscription_plan = element
              break
            }
          }
        }
        // if(this.builderService.is_premium == true && this.builderService.premium_status !== 'active') {
        //   this.builderService.premium_status = project[project.length].status;
        // }
        this.builderService.selectedProjectDomain = project.details[0].domain
        this.builderService.currentProjectType = project.details[0].type
        this.builderService.user_type = project.user_type
        this.builderService.projectAccess = project.details[0].access
        this.builderService.projectStatus = project.details[0].status
        this.projectUrl = this.builderService.selectedProjectDomain
        this.categoriesService.getInitialCategories()
        this.builderService.showUpdateProgress = false
        this.appSettingsService.getContentSettings(this.builderService.selectedProject).subscribe(
          (settings: any) => {
            this.builderService.contentSettings = settings;
            if (settings.mobile_webview_link !== null) {
              this.builderService.mobile_webview_link = settings.mobile_webview_link
            }
          },
          (err) => {
            console.log(err)
          }
        )
        this.finishedFetchingProject = true
        if (this.blockDataService.selectedView == null) {
          this.blockDataService.selectedView = {
            view_name: 'home',
            view_id: 1,
            title: 'home'
          }
        }
      },
      (err) => {
        console.log(err)
      }
    )
  }

  isWishlistActive(): boolean {
    return (
      this.addonsAccess.isAddonActive('Wishlist') ||
      this.addonsAccess.isAddonActive('All Addons Bundle')
    );
  }

  onWishlistClick() {
    if (this.isWishlistActive()) {
        this.viewChange('wishlistView', 16, 'wishlist')
    } else {
        return
    }
  }

  /**
   * Send Update Builder View Request with all blocks data to server after clicking on save btn
   */
  updateBuilderView = () => {
    let allBlocks = this.blockDataService.getAllBlocksData()
    const cleanedBlocks = allBlocks.map((block: any) => {
      if (block.type === 'stacksProducts') {
        const { productsData, categories, ...rest } = block;
        return rest;
      }
      if (block.type === 'stacksCategories') {
        const { categoriesData, ...rest } = block;
        return rest;
      }
      return block;
    });
    let projectId = this.builderService.selectedProject
    this.builderService.showUpdateProgress = true;
    this.versions.setVersion(this.builderService.getSelectedProject(), new Date().toUTCString()).subscribe((response: any) => {
      this.builderService.updateProject(projectId, cleanedBlocks).subscribe(
        (project) => {
          this.builderService.showUpdateProgress = false
          this.builderService.logData('Update Project', 'Update Project', 'Clicked on Update Button').subscribe(
            (response) => {
              
            },
            (err) => {}
          )
          if (this.builderService.getTour()) {
            this.router.navigate(['/app-preview'])
          }
        },
        (err) => {
          console.log(err)
        }
      )
  
      this.mixPanel.track('Update View', {
        projectid: this.builderService.getSelectedProject()
      })

    });
  }

  /**
   * Update website page to Firebase
   */
  updateWebsitePage = () => {
    const allBlocks = this.blockDataService.getAllBlocksData()
    const projectId = this.builderService.selectedProject
    const selectedPage = this.blockDataService.selectedWebsitePage

    if (!selectedPage || !selectedPage.page_id) {
      console.error('No page selected')
      return
    }

    this.builderService.showUpdateProgress = true

    // Filter out header and footer blocks - they are stored in statics and should not be in page blocks.
    // Also strip runtime-only properties (categoriesData, productsData) that must not be persisted.
    const pageBlocks = allBlocks
      .filter((block: any) => block.type !== 'header' && block.type !== 'footer')
      .map((block: any) => {
        if (block.type === 'stacksCategories' || block.type === 'categories') {
          const { categoriesData, ...rest } = block;
          return rest;
        }
        if (block.type === 'stacksProducts') {
          const { productsData, categories, ...rest } = block;
          return rest;
        }
        return block;
      })

    // Find the current page to get its undeletable flag
    const currentPage = this.websitePages.find(p => p.page_id === selectedPage.page_id)

    const pageData = {
      page_name: selectedPage.title,
      all_blocks: JSON.stringify(pageBlocks),
      page_id: selectedPage.page_id,
      title: selectedPage.title,
      undeletable: currentPage?.undeletable || false
    }

    this.pagesService.upsertPage(projectId, pageData)
      .then(() => {
        this.builderService.showUpdateProgress = false

        this.builderService.logData('Update Website Page', 'Update Website Page', 'Clicked on Update Button').subscribe(
          () => {},
          () => {}
        )

        this.mixPanel.track('Update Website Page', {
          projectid: this.builderService.getSelectedProject(),
          pageid: selectedPage.page_id
        })
      })
      .catch((_err: any) => {
        console.error('Error updating page:', _err)
        this.builderService.showUpdateProgress = false
      })
  }

  // Full page label per built-in view, so Arabic reads naturally (e.g. "الصفحة الرئيسية")
  private readonly viewPageLabels: Record<string, string> = {
    home: 'Home Page',
    categoryView: 'Categories Page',
    singleCategoryView: 'Single Category Page',
    singleView: 'Product Page',
    loginView: 'Login Page',
    signupView: 'Signup Page',
    forgotView: 'Forgot Password Page',
    myAccountView: 'My Account Page',
    singleBlogPostView: 'Blog Post Page',
    cartView: 'Cart Page',
    checkoutView: 'Checkout Page',
    aboutView: 'About Page',
    contactView: 'Contact Page',
    termsView: 'Terms Page',
    searchView: 'Search Page',
    wishlistView: 'Wishlist Page',
    referralView: 'Referral Page'
  }

  // Custom views fall back to the generic "{{page}} Page" label
  get selectedViewLabel(): string {
    const view = this.blockDataService.selectedView
    const labelKey = this.viewPageLabels[view?.view_name]
    if (labelKey) {
      return this.translate.instant(labelKey)
    }
    const title = (view?.title || '').toLowerCase().replace(/\b\w/g, (c: string) => c.toUpperCase())
    return this.translate.instant('Named Page', { page: title ? this.translate.instant(title) : '' })
  }

  viewChange = (view_name: string, view_id: number, title: string) => {
    this.blockDataService.sendSelectedView({ view_name: view_name, view_id: view_id, title: title })
    window.location.reload();
  }
  
  newView = () => {
    const viewName = prompt('Enter view name:')
    if(viewName && viewName.trim() !== ''){
      let empty_blocks = this.blockDataService.blankView
      this.viewsService.submitView(viewName, this.builderService.selectedProject).subscribe((response: any) => {
        if (!response.success) {
          alert(response.message)
        } else {
          if (this.builderService.standalone) {
            this.builderService.updateProject(this.builderService.selectedProject, empty_blocks, false, response.view_id, viewName).subscribe((project) => {
              this.blockDataService.sendSelectedView({ view_name: viewName, view_id: response.view_id, title: viewName })
              window.location.reload()

            })
          } else {
            this.blockDataService.sendSelectedView({ view_name: viewName, view_id: response.view_id, title: viewName })
            window.location.reload()
          }
        }
      })
    }
  }


  deleteView = (view_id: any) => {
    this.builderService.showUpdateProgress = true
    this.viewsService.deleteView(this.builderService.selectedProject, view_id).subscribe((response: any) => {
      this.builderService.showUpdateProgress = false
      this.builderService.getViews()
    })
  }

  editMobileVew = (view: any) => {
    const newName = prompt('Enter new page name:', view.view_name);
    if(newName && newName.trim() !== ''){
      this.viewsService.editView(newName, this.builderService.selectedProject, view.view_id).subscribe((response: any) => {
        this.builderService.showUpdateProgress = false
      })
    }
  }
  /**
   * Load all website pages
   */
  loadWebsitePages = () => {
    const projectId = this.builderService.selectedProject
    if (!projectId) return

    this.pagesService.getPages(projectId).subscribe(
      (pages: any) => {
        // Firebase returns an object, not an array - use formatter to convert
        if (pages && typeof pages === 'object') {
          this.websitePages = this.pagesService.allPagesFormatter(pages, projectId)
        } else {
          this.websitePages = []
        }
      },
      (error) => {
        console.error('Error loading pages:', error)
        this.websitePages = []
      }
    )
  }

  /**
   * Get non-static website pages (filters out header/footer)
   * Returns only pages that are not static (excludes pages with page_id containing 'static')
   */
  getNonStaticPages = () => {
    return this.websitePages.filter(page =>
      page.page_id !== 'statics' &&
      !page.page_id.includes('static-')
    )
  }

  /**
   * Navigate to a website page editor
   */
  navigateToWebsitePage = (pageId: string, pageName: string) => {
    this.router.navigate(['/website-builder/edit'], {
      queryParams: { pageId: pageId }
    })
  }

  /**
   * Create a new website page
   */
  createNewWebsitePage = () => {
    const pageName = prompt('Enter page name:')
    if (pageName && pageName.trim() !== '') {
      const projectId = this.builderService.selectedProject
      const pageId = this.blockDataService.getUniqueId(2)

      // Don't include header/footer in page blocks - they're loaded from statics
      // Pages start with empty content blocks (header and footer are added automatically when loading)
      const defaultBlocks: any[] = []

      this.pagesService.submitPage(pageName.trim(), projectId, pageId, JSON.stringify(defaultBlocks)).subscribe(
        () => {
          this.snackBar.open('Page created successfully!', 'Close', {
            duration: 3000
          })
          this.loadWebsitePages()

          // Navigate to the new page editor
          this.router.navigate(['/website-builder/edit'], {
            queryParams: { pageId: pageId }
          })
        },
        (error) => {
          console.error('Error creating page:', error)
          this.snackBar.open('Failed to create page', 'Close', {
            duration: 3000
          })
        }
      )
    }
  }

  /**
   * Edit website page name
   */
  editWebsitePageName = (page: any) => {
    // Prevent editing undeletable pages
    if (page.undeletable) {
      this.snackBar.open('Cannot edit default page name', 'Close', {
        duration: 3000
      })
      return
    }

    const newName = prompt('Enter new page name:', page.page_name)
    if (newName && newName.trim() !== '' && newName !== page.page_name) {
      const projectId = this.builderService.selectedProject

      const renamedPage = {
        page_id: page.page_id,
        page_name: newName.trim(),
        title: newName.trim(),
        all_blocks: page.allBlocks || page.all_blocks || '[]',
        undeletable: page.undeletable || false
      }
      this.pagesService.updatePageName(projectId, page.page_id, newName.trim())
        .then(() => {
          this.snackBar.open('Page name updated successfully!', 'Close', {
            duration: 3000
          })
          this.loadWebsitePages()

          if (this.blockDataService.selectedWebsitePage?.page_id === page.page_id) {
            this.blockDataService.sendSelectedWebsitePage({
              ...this.blockDataService.selectedWebsitePage,
              title: newName.trim()
            })
          }
        })
        .catch((error: any) => {
          console.error('Error updating page name:', error)
          this.snackBar.open('Failed to update page name', 'Close', {
            duration: 3000
          })
        }
      )
    }
  }

  /**
   * Delete website page
   */
  deleteWebsitePage = (page: any) => {
    // Prevent deletion of undeletable pages
    if (page.undeletable) {
      this.snackBar.open('Cannot delete default page', 'Close', {
        duration: 3000
      })
      return
    }

    // Prevent deletion if only one page remains
    // if (this.websitePages.length <= 1) {
    //   this.snackBar.open('You must have at least one page. Cannot delete the last remaining page.', 'Close', {
    //     duration: 3000
    //   })
    //   return
    // }

    if (confirm(`Are you sure you want to delete the page "${page.page_name}"?`)) {
      const projectId = this.builderService.selectedProject

      this.pagesService.deletePage(projectId, page.page_id).subscribe(
        () => {
          this.snackBar.open('Page deleted successfully!', 'Close', {
            duration: 3000
          })
          this.loadWebsitePages()

          // If deleting the current page, navigate to editor without pageId (loads default page)
          if (this.blockDataService.selectedWebsitePage?.page_id === page.page_id) {
            this.router.navigate(['/website-builder/edit'])
          }
        },
        (error) => {
          console.error('Error deleting page:', error)
          this.snackBar.open('Failed to delete page', 'Close', {
            duration: 3000
          })
        }
      )
    }
  }

  /**
   * Clears Token and redirects to login page
   */
  logout = () => {
    this.loginService.logout()
    this.router.navigate(['/login'], { relativeTo: this.route })
  }

  subscriptionList = () => {
    this.router.navigate(['/admin/subList'], { relativeTo: this.route })
  }

  /**
   * Reset the Tour and navigate to the first step of the tour
   */

  resetTour = () => {
    this.builderService.setTour(true).subscribe(
      (response) => {
        // if( this.builderService.projectAccess !== 'webview' ) {
        //   this.router.navigate(['/connectivity']);
        // } else {
        this.router.navigate(['/site-type'])
        // this.router.navigate(['/templates']);
        // }
      },
      (err) => {}
    )
  }

  updateBuilderGlobals = () => {
    this.builderService.showUpdateProgress = true
    let project_id = this.builderService.getSelectedProject()
    this.appSettingsService.setGlobalSettings(project_id, this.builderService.globalSettings).subscribe(
      (data: any) => {
        this.builderService.showUpdateProgress = false
      },
      () => {
        this.builderService.showUpdateProgress = false
      }
    )
    // Get Global Header and Footer
    let global_header = this.builderService.globalHeader
    let global_footer = this.builderService.globalFooter
    // Side menu items are edited (and saved) in the Side Menu block; only write a real, loaded list here
    let globalMenus = this.sideMenuItems.loaded ? this.sideMenuItems.items : this.builderService.globalSettings.menu
    if (Array.isArray(globalMenus)) {
      this.appSettingsService.upsertSettingsByType(String(project_id), 'general_settings', { menus: globalMenus })
    }

    if (this.vendor.isMultiVendor) {
      this.vendor.vendorsList.forEach((vendor) => {
        this.builderService.updateProject(vendor.id, [global_header], false, 99, 'global_header').subscribe((result: any) => {})
        this.builderService.updateProject(vendor.id, [global_footer], false, 98, 'global_footer').subscribe((result: any) => {})
      })
    }

    this.builderService.updateProject(String(localStorage.getItem('selectedProject')), [global_header], false, 99, 'global_header').subscribe((result: any) => {})

    this.builderService.updateProject(String(localStorage.getItem('selectedProject')), [global_footer], false, 98, 'global_footer').subscribe((result: any) => {})
  }

  resetView = () => {
    let requested_view_name = this.blockDataService.selectedView ? this.blockDataService.selectedView.view_name : 'home'
    switch (requested_view_name) {
      case 'categoryView':
        this.blockDataService.blocksData = this.blockDataService.categoryView
        break
      case 'singleCategoryView':
        this.blockDataService.blocksData = this.blockDataService.singleCategoryView
        break
      case 'singleView':
        this.blockDataService.blocksData = this.blockDataService.singleView
        break
      case 'loginView':
        this.blockDataService.blocksData = this.blockDataService.loginView
        break
      case 'signupView':
        this.blockDataService.blocksData = this.blockDataService.signupView
        break
      case 'forgotView':
        this.blockDataService.blocksData = this.blockDataService.forgotView
        break
      case 'myAccountView':
        this.blockDataService.blocksData = this.blockDataService.myAccountView
        break
      case 'singleBlogPostView':
        this.blockDataService.blocksData = this.blockDataService.singleBlogPostView
        break
      case 'cartView':
        this.blockDataService.blocksData = this.blockDataService.cartView
        break
      case 'checkoutView': {
        const clonedCheckout = JSON.parse(JSON.stringify(this.blockDataService.checkoutView))
        this.blockDataService.blocksData = clonedCheckout
        const projectId = String(this.builderService.selectedProject)
        this.checkoutFieldsService.loadFields(projectId)
        this.checkoutFieldsService.fields$.subscribe((fields) => {
          if (!fields.length) return
          const checkoutBlock = clonedCheckout.find((b: any) => b.data?.view === 'checkout')
          if (!checkoutBlock) return
          fields.forEach((field) => {
            checkoutBlock.data[field.key] = field.show
            checkoutBlock.data[field.key + 'Required'] = field.required
          })
          this.blockDataService.blocksData = [...clonedCheckout]
        })
        break
      }
      case 'aboutView':
        this.blockDataService.blocksData = this.blockDataService.aboutView
        break
      case 'contactView':
        this.blockDataService.blocksData = this.blockDataService.contactView
        break
      case 'termsView':
        this.blockDataService.blocksData = this.blockDataService.termsView
        break
      case 'searchView':
        this.blockDataService.blocksData = this.blockDataService.searchView
        break
      case 'wishlistView':
        this.blockDataService.blocksData = this.blockDataService.wishlistView
        break
      case 'referralView':
        this.blockDataService.blocksData = this.blockDataService.referralView
        break
      default:
        this.blockDataService.blocksData = this.blockDataService.blankView
        break
    }
    console.log(requested_view_name, this.blockDataService.blocksData, this.blockDataService.aboutView)
    this.blockDataService.sendRenderAllBlocks()
  }

  purchaseLicense = () => {
    window.open(
      'https://stacksmarket.co/?add-to-cart=15958&variation_id=72793&attribute_packages=premium&product_id=' + this.builderService.getSelectedProject(),
      '_blank' // <- This is what makes it open in a new window.
    )
  }

  /**
   * retrieve the url of the admin dashboard and redirect to it
   */
  adminDashboard = () => {
    this.builderService.loginDemoSite().subscribe(
      (response: any) => {
        window.open(
          response,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      (err) => {
        console.log(err)
      }
    )
  }

  changeLang(language: string) {
    localStorage.setItem('siteLang', language)
    this.languageService.setLanguage(language)
    this.languageService.loadTranslations(language).then(() => {
      this.translate.use(language)
    })
  }

  toggleSidebarFn = () => {
    this.builderService.toggleSidebar = !this.builderService.toggleSidebar
    this.builderService.isListShown = true
  }
}
